import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

export function apiServiceFactory(http: HttpClient) {
  return new ApiService(http); // Đảm bảo rằng factory trả về instance của ApiService
}

@Injectable({
  providedIn: "root",
  useFactory: apiServiceFactory,
  deps: [HttpClient]
})
export class ApiService {
  private readonly API_URL = environment.apiUrl;

  constructor(private http: HttpClient) { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get<T>(endpoint: string, params?: any): Observable<T> {
    const httpParams = this.createHttpParams(params);
    return this.http.get<T>(
      `${this.API_URL}${endpoint}`, {
      params: httpParams
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  post<T>(endpoint: string, body: any, options = {}): Observable<T> {
    return this.http.post<T>(
      `${this.API_URL}${endpoint}`,
      body,
      options,
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  put<T>(endpoint: string, body: any): Observable<T> {
    return this.http.put<T>(`${this.API_URL}${endpoint}`, body);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  patch<T>(endpoint: string, body: any): Observable<T> {
    return this.http.patch<T>(`${this.API_URL}${endpoint}`, body);
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(`${this.API_URL}${endpoint}`);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private createHttpParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== null && params[key] !== undefined) {
          httpParams = httpParams.append(key, params[key].toString());
        }
      });
    }

    return httpParams;
  }
}
